import { render, staticRenderFns } from "./entityFieldCustomForm.vue?vue&type=template&id=5fa06290"
import script from "./entityFieldCustomForm.vue?vue&type=script&lang=js"
export * from "./entityFieldCustomForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports